<template>
  <div class="changesVerification">
    <slotModal
      :id-modal="'changesVerif'"
      :modal-title="'Verifikasi Perubahan'"
      v-model="dialog"
      @close="close"
    >
      <template v-slot:modal-content>
        <div class="card-body">
          <p class="f-Overpass f-14 f-w-400 f-c-black p-x-20 p-t-10 p-b-10 m-0">
            Kode verifikasi telah dikirim ke nomor
            <span class="f-w-600">+62{{ dataAkun.telp }}</span
            >. Periksa WhatsApp anda dan masukkan kode
          </p>
          <div
            id="otp"
            class="inputs d-flex flex-row justify-content-center mt-2 p-x-24"
          >
            <input
              v-for="(input, index) in inputs"
              :key="index"
              :id="'input' + index"
              class="otp-input m-2 text-center form-control f-Overpass"
              type="number"
              maxlength="1"
              v-model="inputs[index]"
              @input="
                checkValueInputs()
                  ? handleInput(index, $event)
                  : postWithInputs()
              "
            />
          </div>
          <p class="f-Overpass f-13 f-w-400 text-center f-c-grey m-0 p-t-32">
            Kirim ulang kode dalam
            <span class="f-w-500" style="color: #000">{{ timeStep }}</span>
          </p>
          <p class="f-Overpass f-13 f-w-400 text-center f-c-grey p-t-4">
            Belum menerima kode?
            <button
              type="button"
              class="btn btn-link p-0 text-decoration-none"
              @click="sendOtp"
              :disabled="timeStep !== '00:00' ? true : false"
            >
              <span class="f-c-blue f-13">Kirim Ulang Kode</span>
            </button>
          </p>
          <div class="p-a-20">
            <button
              type="button"
              class="btn btn-primary w-100 f-Overpass f-16"
              @click="handleButtonClick"
              :disabled="disableBtn() ? true : false"
            >
              <span
                class="spinner-border text-light f-16 spiner-border-sm"
                v-if="btnVerifikasi"
              ></span>
              <span v-if="!btnVerifikasi">Verifikasi</span>
            </button>
          </div>
        </div>
      </template>
    </slotModal>
  </div>
</template>

<script>
import slotModal from "@/components/slots/slotModal.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "ChangesVerification",
  components: {
    slotModal,
  },
  data() {
    return {
      inputs: Array.from({ length: 6 }, () => ""),
      timeStep: "00:00",
      timeInterval: null,
      timeEnd: new Date(new Date().getTime() + 60000).getTime(),
      btnVerifikasi: false,
      dialog: false,
    };
  },

  computed: {
    ...mapState("akun", {
      dataAkun: "dataAkun",
      dataPassword: "dataPassword",
    }),
  },
  methods: {
    ...mapActions({
      postUpdatePassword: "akun/postUpdatePassword",
      postOtp: "akun/postOtp",
      // postDataRegisterAuth: "auth/postDataRegisterAuth",
      // postRequestOtp: "auth/postRequestOtp",
    }),
    open() {
      this.countdownStart();
      this.$nextTick(() => {
        this.$refs.input0[0].focus();
      });
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },

    checkValueInputs() {
      let otp = this.inputs.join("").replace(/\D/g, "");
      if (otp.length != 6) {
        return true;
      } else {
        return false;
      }
    },

    async postWithInputs() {
      let otp = this.inputs.join("").replace(/\D/g, "");
      let data = {
        otp: otp,
        password_lama: this.dataPassword.oldPassword,
        password_baru: this.dataPassword.newPassword,
      };
      await this.postUpdatePassword(data).then((res) => {
        // console.log(res);
        if (res.data.status === 200) {
          this.$toast.success("Berhasil merubah sandi", { position: "top" });
          this.close();
          location.reload();
        }
        if (res.data.status !== 200) {
          if (
            res.data.message ==
            "crypto/bcrypt: hashedPassword is not the hash of the given password"
          ) {
            this.$toast.error("password lama salah", { position: "top" });
          } else {
            this.$toast.error(res.data.message, { position: "top" });
          }
        }
      });
    },

    async handleButtonClick() {
      this.btnVerifikasi = true;
      let otp = this.inputs.join("").replace(/\D/g, "");
      let data = {
        otp: otp,
        password_lama: this.dataPassword.oldPassword,
        password_baru: this.dataPassword.newPassword,
      };
      await this.postUpdatePassword(data).then((res) => {
        // console.log(res);
        if (res.data.status === 200) {
          this.$toast.success("Registrasi Berhasil", { position: "top" });
          this.close();
        }
        if (res.data.status !== 200) {
          this.$toast.error(res.data.message, { position: "top" });
          this.close();
        }
      });
    },

    countdown() {
      try {
        let timeNow = new Date().getTime();
        let distance = this.timeEnd - timeNow;

        if (distance < 0) {
          clearInterval(this.timeInterval);
          this.timeStep = "00:00";
          // this.timeEnd = new Date(new Date().getTime + 60000).getTime();
          return;
        }

        let minutes = String(
          Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        ).padStart(2, "0");
        let seconds = String(
          Math.floor((distance % (1000 * 60)) / 1000)
        ).padStart(2, "0");

        this.timeStep = `${minutes}:${seconds}`;
      } catch (error) {
        console.log(error);
      }
    },
    countdownStart() {
      this.timeInterval = setInterval(this.countdown, 1000);
      // console.log(this.timeInterval);
      this.countdown();
    },

    disableBtn() {
      let otp = this.inputs.join("").replace(/\D/g, "");
      if (otp.length != 6) {
        return true;
      } else {
        return false;
      }
    },

    handleInput(index, event) {
      const inputs = document.querySelectorAll("#otp > *[id]");
      const inputValue = event.target.value;
      if (inputValue.length === 1 && /^\d+$/.test(inputValue)) {
        this.inputs[index] = inputValue;
        if (index < inputs.length - 1) {
          inputs[index + 1].focus();
        }
      } else if (event.inputType === "deleteContentBackward" && index) {
        // Handle backspace
        this.inputs[index] = "";
        inputs[index - 1].focus();
      } else {
        this.inputs[index] = "";
      }
    },

    async sendOtp() {
      this.postOtp().then((res) => {
        if (res.status !== 200) {
          this.$toast.error(res.message, { position: "top" });
        } else {
          this.$toast.success(res.message, { position: "top" });
          this.timeEnd = new Date(new Date().getTime() + 60000).getTime();
          this.countdownStart();
        }
      });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.card-one {
  border-radius: 16px;
  background: var(--primary-white, #fff);
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
  align-items: center;
  width: -webkit-fill-available;
}

.profile-pic {
  width: 110px; /* Set the width and height of the circular image */
  height: 110px;
  border-radius: 70%; /* Create a circular shape */
  position: absolute; /* Position the image absolutely */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 1%;
  left: 50%; /* Position horizontally at the center */
  transform: translate(-50%, -50%);
}

.sd-heading {
  background-color: #206cfe;
  height: 70px;
  color: #fff;
  align-self: stretch;
  border-radius: 16px 16px 0px 0px;
  background: var(--primary-product-smartlink, #206cfe);
}

/* .spsl-1 {
  color: #206cfe;
  font-size: 16px;
} */

/* .footer {
  width: 100%;
  height: 145px;
  padding: 15px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  gap: 8px;
  background-color: white;
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
} */
.spn-2 {
  color: #007bff;
}

.button-eye {
  transform: translateY(30%);
  position: absolute;
  right: 0;
  padding-right: 30px;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}

.otp-input {
  border-top: none !important;
  border-right: none !important;
  border-left: none !important;
  border-radius: 0 !important;
  font-size: 48px !important;
  height: 60px;
  padding: 0 !important;
  color: #206cff !important;
  font-weight: 700;
}
</style>
